import React from 'react';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';
import {
  formatTimelineChangeItems,
  getTimelineEventDetails,
} from 'common/Workqueue/timelineEventUtils';

const ServiceAuthorizationEditEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data');

  const eventChanges = get(timelineEvent, 'changes', []);
  const employeeName = get(additionalData, 'employee_name');

  const icon = 'IconPencil';
  const message = `Edited by ${employeeName}`;
  const date = formatDate(timelineEvent.timestamp);
  const eventDetailItems = formatTimelineChangeItems({
    eventChanges,
    additionalData,
    excludedFieldNames: ['assigned_to', 'review_reason'],
    additionalDataFields: ['review_reason'],
    noteFieldNames: ['in_review_note'],
    labelOverrides: { in_review_note: 'Review Note' },
  });
  const eventDetails = getTimelineEventDetails(eventDetailItems, date);

  const formattedTimelineEvent = {
    icon,
    message,
    date,
    eventDetails,
  };

  return (
    <BaseTimelineEvent {...formattedTimelineEvent} />
  );
};

ServiceAuthorizationEditEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default ServiceAuthorizationEditEvent;
